import React from 'react';
import axios, { baseUrl } from 'helpers/axios';

import {
  Container,
  Title,
  TextInput,
  Button,
  Form,
  Image,
  Label,
  ConfirmationModal,
  ModalPosition,
} from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { useToasts, useFlash, useUser, useLayout } from 'hooks';
import { CloseButton } from 'ui/components/shared';

export const TFAReset = () => {
  const [token, setToken] = React.useState('');
  const [showCancelModal, setShowCancelModal] = React.useState(false);
  const { setLayoutLoading } = useLayout();
  const { errorToast } = useToasts();
  const { setFlash } = useFlash();
  const { challenges, redirectTo } = useUser();
  const timestamp = React.useRef(new Date().getTime());

  const redirectToSettings = () => redirectTo('/settings?tab=security');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLayoutLoading(true);
      const response = await axios.post('/challenges/otp/verify', { token });
      if (response.status === 200) {
        if (response.data?.success) {
          setFlash({
            title: '2FA reset',
            message: 'Your 2FA has been successfully reset!',
          });
          redirectToSettings();
          return;
        } else {
          errorToast('Token code is wrong!');
        }
      }
    } catch (error) {
      errorToast({ error, default: 'Error: 2FA reset.' });
    }
    setLayoutLoading(false);
  };

  return (
    <AuthLayout show={challenges.valid} justifyContent="center">
      <Container width="80%" maxWidth="480px" height="auto">
        <Container alignItems="center" mb="xl">
          <Image alt="2FA" src="/assets/img/2FA.png" />
        </Container>
        <Title mb="m">Your security matters</Title>
        <Title type="h3" variant="grey" mb="xs">
          <strong>1.</strong>Dowload and Install a supported TOTP Athenticator App
          <br />
          <strong>2.</strong>Open the app
          <br />
          <strong>3.</strong>Pair your app by scanning the QR Code below
        </Title>
        <Container alignItems="center" mb="xs">
          <Image
            width="152px"
            src={`${baseUrl}/challenges/otp/setup/?$renew=true&$qr=true&$format=otpauth_url&t=${timestamp.current}`}
            alt="QR Code"
            onError={(error) => {
              errorToast({ error, default: 'Error: 2FA reset.' });
              redirectToSettings();
            }}
          />
        </Container>
        <Title type="h3" variant="grey" mb="m">
          <strong>4.</strong>Verifying the pairing by entering the code below
        </Title>
        <Form onSubmit={handleSubmit}>
          <Container mb="xxs">
            <Label htmlFor="token" mb="xs">
              Your token code
            </Label>
            <TextInput
              id="token"
              name="token"
              type="token"
              length={6}
              placeholder="6-digit code"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
              autoFocus
            />
          </Container>
          <Button type="submit" my="m">
            NEXT
          </Button>
        </Form>
      </Container>
      <CloseButton title="Cancel" onClick={() => setShowCancelModal(true)} />
      <ConfirmationModal
        show={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        onConfirm={() => redirectTo('/settings?tab=security')}
        position={ModalPosition.CENTER_CENTER}
        adjustPosition={false}
      >
        Are you sure you want to cancel the 2FA reset?
        <br />
        <br />
        You will still be prompted to setup the 2FA on your next login.
      </ConfirmationModal>
    </AuthLayout>
  );
};
